exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filiale h1[data-v-dc9b2e42]{margin-bottom:20px;font-size:28px;font-weight:700}.filiale .main[data-v-dc9b2e42]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.filiale .main .content[data-v-dc9b2e42]{margin:10px 0;padding:0 10px;width:330px;border:1px solid #ddd}.filiale .main .content .cnResult[data-v-dc9b2e42]{width:300px;line-height:30px;word-break:break-all}", ""]);

// exports
